import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import { SubWebNavigation } from "../../components/organisms/index";
//API
import { getSubNavigation } from "../../api/requests";
//Context
import { StoreContext } from "../../context/StoreContext";
//Utils
import { lang } from "../../translations";

const NavigationTemplate = ({ match, ...props }) => {
  const context = useContext(StoreContext);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [state, setState] = useState({
    loading: true,
    hasError: false,
    data: []
  });

  const getLang = lang();

  const { id: path, activeColor, activeColorBar } = context.state.subWebNav;

  const getData = async () => {
    try {
      const data = await getSubNavigation({
        path,
        lang: getLang,
        history: props.history
      });

      setState(prevState => {
        return {
          ...prevState,
          data: data.tabs,
          loading: false
        };
      });
    } catch (error) {
      setState(prevState => {
        return { ...prevState, loading: false, hasError: true };
      });
    }
  };

  useEffect(() => {
    getData();
  }, [path]);

  const navProps = {
    content: context.state.subWebNav,
    activeColor: activeColorBar || activeColor || "#0EB4BD",
    isWhite: activeColorBar.includes("#fff") || activeColor.includes("#fff"),
    setDropdownOpen,
    isDropdownOpen,
    lang: getLang,
    isExternal: context.state.isExternal,
    ...state,
    ...props
  };

  return <SubWebNavigation {...navProps} />;
};

NavigationTemplate.propTypes = {
  match: PropTypes.object
};

export default withRouter(NavigationTemplate);
